export const REFRESH_INTERVAL_IN_MILLISECONDS = 60000;
